export { default as ArrowsExpandSolidIcon } from './ArrowsExpandSolidIcon';
